const PageBanner = ({ title, image = "/img/blog/1.webp" }) => {
  return (
    <section
      className="page-banner"
      style={{ backgroundImage: `url("${image}")` }}
      role="banner"
      aria-label={title}
    >
    </section>
  );
};

export default PageBanner;